import { ReactNode } from 'react';

/**
 * 空值占位：详情/明细里没有值的字段统一渲染弱化的「-」。
 *
 * 为什么单独做件：`|| '-'` 散落在几十处，同一个详情里空值的颜色/粗细各不相同，
 * 一屏十几个横杠时视觉噪音很大（工单详情实测 24 个字段中 15 个为空）。这里把「空值长什么样」
 * 收敛到一处（`.bcc-desc-empty`，见 styles/components.css），页面只需判断有无值。
 *
 * 用法：
 * - 纯空值：`<EmptyValue />`；
 * - 有值渲染值、无值渲染占位：`{valueOrEmpty(row.email)}`（`0`/`false` 属有效值，不判空）；
 * - 需要别的占位文案（如「未填写」）：`<EmptyValue text="未填写" />`。
 */
export interface EmptyValueProps {
  /** 占位文案（默认「-」） */
  text?: string;
}

export default function EmptyValue({ text = '-' }: EmptyValueProps) {
  return <span className="bcc-desc-empty">{text}</span>;
}

/**
 * 值为空则渲染占位（`null`/`undefined`/空串视为空；`0`/`false`/空数组按有效值原样渲染）。
 * 返回 ReactNode，便于直接放进 `Descriptions` 的 `value` 或表格 `render`。
 */
export function valueOrEmpty(value: ReactNode, text?: string): ReactNode {
  if (value === null || value === undefined || value === '') return <EmptyValue text={text} />;
  return value;
}
